import React from 'react';
import SafeIcon from '../common/SafeIcon';

const TOPMATE_URL = 'https://topmate.io/acharya_ji_ajay_l_agrawal/2021138?utm_source=public_profile&utm_campaign=acharya_ji_ajay_l_agrawal';

export default function ScarcitySection() {
  return (
    <section className="py-20 px-6 md:px-12 bg-brand-accent">
      <div className="max-w-5xl mx-auto">
        <div className="bg-brand-dark text-brand-light p-10 md:p-16 rounded-sm relative overflow-hidden shadow-2xl">
          <div className="absolute top-0 right-0 w-48 h-48 bg-brand-gold/10 rounded-bl-full pointer-events-none"></div>
          <div className="relative z-10 flex flex-col md:flex-row items-center gap-10 text-center md:text-left">
            <div className="flex-shrink-0">
              <div className="w-20 h-20 rounded-full border-2 border-brand-gold/50 flex items-center justify-center bg-brand-gold/10">
                <SafeIcon name="Clock" className="text-4xl text-brand-gold" />
              </div>
            </div>
            <div className="flex-grow">
              <h3 className="text-3xl font-serif mb-4 text-white">
                Why Acharyaji Takes Only Limited Clients
              </h3>
              <p className="text-stone-300 font-medium leading-relaxed text-lg max-w-2xl">
                A Vedic Astrology and Vastu consultation requires extensive pre-session chart work per client. To preserve the mathematical precision that serious decisions demand, intake is strictly limited. This is not artificial scarcity. It is the cost of quality.
              </p>
            </div>
            <div className="flex-shrink-0 w-full md:w-auto mt-6 md:mt-0">
              <a
                href={TOPMATE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full text-center px-10 py-5 bg-brand-gold text-brand-dark hover:bg-white transition-all duration-400 text-lg font-bold tracking-widest uppercase rounded-sm shadow-lg"
              >
                Secure Slot
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}